import React, {Suspense, useLayoutEffect} from 'react';
import {Navigate} from 'react-router';
import {RoleType} from '@di-shared/api/di/type';
import useFirebaseStore from '@di-shared/features/environment/firebaseStore';
import useAvailableComponentKr from '@di-shared/features/home/kr/useAvailableComponent.kr';
import {isEventDuration} from '@di-shared/pages/[vin]/capital/event1';
import {ROUTE_PATHS} from '@di-shared/routes';
import {WebviewUtils} from '@shared/webviewUtils';

export interface CapitalBridgeProps {
  vin: string;
}

function CapitalBridge({vin}: CapitalBridgeProps) {
  return (
    <Suspense>
      <Inner vin={vin} />
    </Suspense>
  );
}

function Inner({vin}: CapitalBridgeProps) {
  const {isCcsFullEnroll, isMainSupport, role} = useAvailableComponentKr({vin});
  const {checkCapitalVinWhitelist} = useFirebaseStore(({checkCapitalVinWhitelist}) => ({checkCapitalVinWhitelist}));
  // [2025-08-25:cy.seo] FIXME:  이벤트 후 삭제 EVENT2
  useLayoutEffect(() => {
    if (!(checkCapitalVinWhitelist(vin) || isEventDuration())) {
      return;
    }
    if (window.location.search && window.location.search.includes('from=event')) {
      // 이벤트 페이지가 바로 뜰떄는 바텀시트가 안떳으면 좋겠음
      // 따라서 한 1분동안 바텀시트가 안뜨도록 꼼수를 쓰는것!!
      const after1Minutes = new Date();
      after1Minutes.setMinutes(after1Minutes.getMinutes() + 1, 0, 0);
      localStorage.setItem('event1BlockedUntil', after1Minutes.getTime().toString());

      WebviewUtils.openNewWebView({
        url: window.location.origin + ROUTE_PATHS.CAPITAL_EVENT_1.getFullPath(vin),
        isModal: true,
        isNavigationBar: false,
        isToolBar: false,
      });
    }
  }, []);

  if (!isCcsFullEnroll || !isMainSupport || role === RoleType.NON_CCS || role === RoleType.UNREGISTERED_SPEC) {
    return (
      <Navigate
        to={ROUTE_PATHS.CAPITAL_SHORT.getFullPath(vin)}
        replace
      />
    );
  }

  return (
    <Navigate
      to={ROUTE_PATHS.HOME_FINANCE_TAB.getFullPath(vin)}
      replace
    />
  );
}

export default CapitalBridge;
